﻿import './sections.css'
export default function TrustSection() {
  const items = [
    { icon: '🏢', label: 'Big 4 Integration', sub: 'Powering CRM for 15,000+ clients' },
    { icon: '🎓', label: 'Fortune 100 Partner', sub: '100,000+ corporate learners' },
    { icon: '🌍', label: 'Global Scale', sub: 'Enterprise-grade infrastructure' },
    { icon: '🔒', label: 'Enterprise Security', sub: 'Meets Big 4 & Fortune 100 standards' },
  ]
  return (
    <section className="trust-section section">
      <div className="container">
        <h3 className="trust-title">Enterprise-Proven at Global Scale</h3>
        <div className="trust-grid">
          {items.map(i => (
            <div key={i.label} className="trust-card">
              <div className="trust-icon">{i.icon}</div>
              <div className="trust-text">
                <strong>{i.label}</strong>
                <span>{i.sub}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

